// Ignore REACT_APP_API_BASE_URL — Amplify still has the live URL in the
// console, and that was winning every deploy. Live only when the build is
// explicitly marked production.
// const UAT_API = "http://127.0.0.1:8000/api/v1/";
const UAT_API = "https://b2cuat.vlookup.ai/api/public/api/v1/";
const LIVE_API = "https://vlookup.ai/api/public/api/v1/";

export const API_BASE_URL =
  process.env.REACT_APP_ENV === "production" ? LIVE_API : UAT_API;
